import script from "./BookingPublicPage1.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingPublicPage1.vue?vue&type=script&setup=true&lang=js"

import "./BookingPublicPage1.vue?vue&type=style&index=0&id=6cca90e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cca90e8"]])

export default __exports__